import React, { Component } from 'react';
import LinkIcon from '@material-ui/icons/TransitEnterexit';

import '../../../../../chat.css';

/**
 * A message type that shows a link box.
 */
class FileMessage extends Component {
    render() {
        return(
            <div className={'file-message-container'}>
                <a  rel={'noopener noreferrer'} onClick={()=>this.props.downloadFile(this.props.url)} >
                    <div className={'link-message-content-container'}
                         style={{backgroundColor: this.props.isUser ? this.props.chatConfig.speechBubbleUserColor : this.props.chatConfig.speechBubbleBotColor}}>

                        <span style={{color: this.props.isUser ? this.props.chatConfig.fontUserColor:this.props.chatConfig.fontBotColor }}>{this.props.title}</span>
                        <LinkIcon className={'link-icon'}/>
                    </div>
                </a>
            </div>
        );
    }
}

export default FileMessage;
